module.exports = __webpack_public_path__ + "static/media/blueTheme-girl.f24ea9a2.svg";